export default __webpack_public_path__ + "static/media/input-search-icon.f772c008.svg";